import React, { Component } from 'react'
import { connect } from 'react-redux';

import ArticlePreview from '../ArticlePreview';

class ArticleList extends Component {

    renderArticlePreview( article, i, uniqueId, activeArticle, sites ) {

        if ( sites.activeSite === article.site ) {

            return (
                <ArticlePreview key={ uniqueId } i={i} uniqueId={ uniqueId } article={article} active={activeArticle} />
            )

        } else {

            return null;

        }

    }

    render() {

        let { articles, sites } = this.props;

        return(
            <div className="list-group item-list">
                {
                    // Map the articles and render the preview
                    articles.items.map((article, i) => {

                        // create a unique id based on the site id and article id
                        let uniqueId = article.site.id + '-' + article.id;

                        if (sites.activeSite === article.site) {
                            return this.renderArticlePreview(article, i, uniqueId, articles.activeArticle, sites )
                        } else {
                            return false;
                        }

                    })
                }
            </div>
        )

    }

}

function mapStateToProps( state ) {
    return {
        articles: state.articles,
        sites: state.sites
    }
}

export default connect( mapStateToProps )(ArticleList);


/** WEBPACK FOOTER **
 ** ./src/components/ArticleList/index.js
 **/